module.exports = __webpack_public_path__ + "img/Executor-fees.60242ccf.svg";